module.exports = __webpack_public_path__ + "static/media/step2@1x.583cacfa.webm";